/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3.7527 21.5141C1.6802 21.5141 0 19.834 0 17.7614V4.2516C0 3.0081 1.008 2 2.2516 2h6.194c.5436 0 1.0565.2525 1.388.6835l2.1284 2.7669a.2502.2502 0 0 0 .1983.0976h7.1036c1.2436 0 2.2517 1.0081 2.2517 2.2516v2.7066h.4818c1.3197 0 2.2782 1.2548 1.9309 2.528l-1.9104 7.0051a2.0015 2.0015 0 0 1-1.931 1.4748H3.7527ZM1.5011 4.2516c0-.4145.336-.7505.7505-.7505h6.194c.0776 0 .1509.036.1982.0976l2.1284 2.767c.3315.4309.8444.6834 1.3881.6834h7.1036c.4146 0 .7506.336.7506.7505v2.7066H9.4099a2.3624 2.3624 0 0 0-2.2792 1.7408l-1.5449 5.6647c-.2702.9908-.4784 1.68-1.3675 1.9291l-.0298.0082a2.7502 2.7502 0 0 1-1.0825.0698c-.9283-.2779-1.605-1.1386-1.605-2.1574V4.2516ZM6.1145 20.013h13.9724a.5004.5004 0 0 0 .4828-.3687l1.9105-7.005c.0868-.3183-.1529-.6321-.4828-.6321H9.4099a.8614.8614 0 0 0-.831.6348L7.034 18.3067c-.1804.6616-.5018 1.2361-.9195 1.7063Z"
    clipRule="evenodd"
  />,
  'Folder'
);
